import { Injectable } from '@angular/core';

import { Customer } from '../../models/customer';

/**
 * Decides whether a customer is blocked, and whether that block prevents ordering.
 *
 * The base class is ERP-agnostic and always answers "not blocked" — the block field lives in
 * different places per ERP, so `getBlockedCode` is overridden per ERP (see
 * `BcCustomerBlockedService` in gung-standard-bc).
 *
 * `isBlocked` and `blocksOrdering` are separate so a customer can permit ordering for some
 * block codes while still showing the marker.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerBlockedService {
  getBlockedCode(customer: Customer): string | undefined {
    return undefined;
  }

  isBlocked(customer: Customer): boolean {
    return !!this.getBlockedCode(customer);
  }

  blocksOrdering(customer: Customer): boolean {
    return this.isBlocked(customer);
  }

  getBlockedTranslationKey(customer: Customer): string | undefined {
    const code = this.getBlockedCode(customer);
    return code ? 'CUSTOMER_BLOCKED_' + code.toUpperCase() : undefined;
  }
}
